import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   getCourseStageSignoffRequest as courseStageSignoffRequestFromMonolith,
   GetCourseStageSignoffRequestOptions,
   GetCourseStageSignoffRequestResult,
} from '~/monolith-api';

export type { GetCourseStageSignoffRequestOptions, GetCourseStageSignoffRequestResult };

const getCourseStageSignoffRequestSchema = z.object({
   signoff_requestid: z.number(),
   course_assignmentid: z.number(),
});

export async function getCourseStageSignoffRequest(options: GetCourseStageSignoffRequestOptions) {
   return await courseStageSignoffRequestFromMonolith(options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { signoff_requestid, course_assignmentid } = getCourseStageSignoffRequestSchema.parse(
         req.body
      );
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getCourseStageSignoffRequest({
         signoff_requestid,
         course_assignmentid,
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getCourseStageSignoffRequestFromClient = (
   options: GetCourseStageSignoffRequestOptions
): ReturnType<typeof getCourseStageSignoffRequest> => {
   return bff()
      .post(`/signoffs/getCourseStageSignoffRequest`, {
         ...options,
      })
      .then(response => response.data);
};
